import { getAccountRestrictionDataInputFields } from "../../../utils/helpers/intakeForm";

import Card from "../../Card";
import DynamicGroupField from "../../Form/DynamicGroupField";

import useIntakeFormStore from "../../../store/IntakeForm.store";

const SecurityRestrictionsCard = ({ id, headerIcon, isEnabled, isTest }) => {
  const [formState] = useIntakeFormStore((state) => [
    state.data.formState,
    state.data.formOptions,
  ]);
  
  const isLocked = formState.isFormLocked;

  const accountRestrictionDataInputFields =
    getAccountRestrictionDataInputFields(formState);

  const accountRestrictionTooltipContent = () => (
    <>
      <p className={`tooltip__content-body-text`}>
        Note: Restrictions are limited to six per proposal.
      </p>
      <br />
      <p className={`tooltip__content-body-text`}>
        Understanding your options:
      </p>
      <ul className={`tooltip__content-list`}>
        <li className={`tooltip__content-list-item`}>
          Don't Buy — Do not buy the security (but can sell the security).
        </li>
        <li className={`tooltip__content-list-item`}>
          Don't Sell — Do not sell the security (but can buy the security).
        </li>
        <li className={`tooltip__content-list-item`}>
          Don't Trade - Do not buy or sell the security.
        </li>
        <li className={`tooltip__content-list-item`}>
          Don't Hold: Portfolio will not hold the security. Any portfolio
          holdings will be liquidated.
        </li>
        <li className={`tooltip__content-list-item`}>
          Minimum Exposure — Minimum holding as a percentage of the total
          portfolio. If minimum holding conflicts with “Don't Buy”, “Don't
          Hold”, or “Don't Trade” instructions, minimum holdings will not be
          binding.
        </li>
        <li className={`tooltip__content-list-item`}>
          Maximum Exposure — Maximum holding as a percentage of the total
          portfolio. If maximum holding conflicts with “Don't Sell”, “Don't
          Trade”, or “Don't Trade” instructions, maximum holdings will not be
          binding.
        </li>
      </ul>
    </>
  );

  return (
    <Card
      title="Enter Account Security Restrictions"
      id={id}
      openByDefault={isEnabled}
      disabled={!isEnabled}
      errorCount={
        formState.taxLotData.totalErrorCount +
        formState.accountRestrictionData.totalErrorCount
      }
      headerIcon={headerIcon}
      tooltip={{
        heading: "Account Restrictions",
        content: accountRestrictionTooltipContent(),
        direction: "top",
      }}
      isTest={isTest}
    >
      {isEnabled && (
        <div className="card__content">
          <DynamicGroupField
            fieldArrayName="accountRestrictionData"
            store="intake"
            inputFields={accountRestrictionDataInputFields}
            disabled={isLocked}
            isTest={isTest}
            className="security-restrictions"
          />
        </div>
      )}
    </Card>
  );
};

// SecurityRestrictionsCard.propTypes = {
//   id: PropTypes.string,
//   headerIcon: PropTypes.string,
//   isEnabled: PropTypes.bool,
//   isTest: PropTypes.bool,
// };

export default SecurityRestrictionsCard;
